import React from 'react';

function Error() {
  return (
    <div>
      <h1> </h1>
      <h1>404</h1>
      <p>Oh no, sembra che tu abbia trovato un...</p>
      <h1>Dead Link</h1>
      <img
        src="./images/deadlink.png"
        alt="Death Link"
        style={{ width: '100%', maxWidth: '400px' }}
      />
    </div>
  );
}

export default Error;
